import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { AccessRequest, RequestState } from '@synergetx/puppet-interview-types';
import { memo, useEffect, useState } from 'react';

interface Props {
    allRequests: AccessRequest[] | null;
    setRequestsToShow: React.Dispatch<React.SetStateAction<AccessRequest[] | null>>;
}

const AccessRequestTabs = ({ allRequests, setRequestsToShow }: Props) => {
    const [activeButton, setActiveButton] = useState<RequestState>(RequestState.REQUESTED);

    useEffect(() => {
        if (!allRequests) return;
        setRequestsToShow(allRequests.filter((user) => activeButton === user.status));
    }, [activeButton, setRequestsToShow, allRequests]);

    return (
        <Box
            sx={{
                flexDirection: 'row',
                display: 'flex',
                alignItems: 'center',
            }}
        >
            <ToggleButtonGroup value={activeButton} sx={{ marginLeft: '1rem' }}>
                <ToggleButton
                    value={RequestState.REQUESTED}
                    onClick={() => setActiveButton(RequestState.REQUESTED)}
                >
                    Requested
                </ToggleButton>

                <ToggleButton
                    value={RequestState.APPROVED}
                    onClick={() => setActiveButton(RequestState.APPROVED)}
                >
                    Approved
                </ToggleButton>

                <ToggleButton
                    value={RequestState.DENIED}
                    onClick={() => setActiveButton(RequestState.DENIED)}
                >
                    Denied
                </ToggleButton>
            </ToggleButtonGroup>
        </Box>
    );
};

export default memo(AccessRequestTabs);
